import { Phone } from 'iconoir-react'
import { Link } from 'react-router-dom'

// Mobile-only sticky action bar (below 900px); the header's "Get Started"
// button takes over on desktop, matching the original site's swap between
// .fs-navcta and .fs-callbar at the same 900px breakpoint.
export function CallBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-3 border-t border-n-200 bg-n-100 min-[900px]:hidden">
      <a
        href="tel:+19568871317"
        className="flex min-h-[60px] items-center justify-center gap-2 text-body font-medium text-ink transition-colors active:bg-n-400"
      >
        <Phone className="h-[22px] w-[22px] shrink-0 text-flow" strokeWidth={2} />
        Call
      </a>
      <Link
        to="/what-we-do"
        className="flex min-h-[60px] items-center justify-center border-x border-n-200 text-body font-medium text-ink transition-colors active:bg-n-400"
      >
        What We Do
      </Link>
      <Link
        to="/contact"
        className="flex min-h-[60px] items-center justify-center bg-flow text-body font-semibold text-n-100 transition-colors active:bg-flow-lo"
      >
        Get Started
      </Link>
    </div>
  )
}
